<div class="modal-header">
  <h4 class="modal-title  ms-3">Reject Claim</h4>
  <button type="button" class="btn-close me-2" data-bs-dismiss="modal" aria-label="Close" (click)="this.activeModal.close()"></button>
</div>

<ng-container *ngIf="showSuccess">
  <div class="modal-body mx-3">
    <div class="bg-light rounded p-3 mb-3">
      <div class="text-center pt-3">
        <svg class="text-danger" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
        <div class="text-danger fs-4 fw-bolder lh-sm mt-1">REJECTED</div>
        <div class="mt-3 fw-bolder text-dark">Claim {{claimDto.claimId}} has been rejected.</div>
        <p>The repair center has been notified and this claim has been pushed to E2.</p>
        <p>Any further changes will need to be done in E2 and manually communicated to the repair center.</p>
        <a [href]="e2Url" class="btn btn-outline-primary btn-bg-white rounded mb-3" target="_blank">
          <span class="me-2">View Claim in E2</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
        </a>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isError">
  <div class="modal-body mx-3">
    <div class="alert alert-danger alert-outline-coloured" role="alert">
      <div class="alert-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
      </div>
      <div class="alert-message">
        <p class="mb-0"><strong>Claim was not pushed to E2.</strong></p>
        <p class="mb-0">An error occurred, and this claim has not been pushed to E2, nor has the repair center been notified.</p>
        <p class="mb-0">You will need to manually enter the claim in E2.</p>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!showSuccess && !isError">
  <div class="modal-body mx-3">
    <app-discrepancies [claimDto]="claimDto" [customerRecordMatch]="customerRecordMatch"/>
    <div class="row mb-3">
      <div class="col-lg-8 mb-3 mb-lg-0 d-flex">
        <div class="flex-fill bg-light rounded px-4 pt-3 pb-4">
          <app-repair-work-items [repairsDto]="repairsDto"/>
        </div>
      </div>
      <div class="col-lg-4 d-flex">
        <div class="flex-fill bg-light rounded px-4 py-3">
          <app-claim-total [claimDto]="claimDto" [repairTotal]="repairTotal" [claimTotalCssClass]="'text-danger'"/>
        </div>
      </div>
    </div>
      <fieldset class="mb-3">
        <label class="form-label mb-0 lh-sm" for="rejectClaimFinalMessage">Final message explaining rejection to repair center</label>
        <textarea 
            [(ngModel)]="finalMessage"
            [ngClass]="{'is-invalid': !isFinalMessageValid}"
            (keyup)="validateFinalMessage()"
            class="form-control" id="rejectClaimFinalMessage"
            name="rejectClaimFinalMessage" type="text" rows="5">
        </textarea>
        <div class="invalid-feedback lh-sm">Please provide a final message for the rejected claim.</div>
      </fieldset>
  </div>
  
  <div class="modal-footer">
    <div class="px-3">
      <button [disabled]="isBusy" class="btn btn-lg btn-outline-secondary me-3" (click)="this.activeModal.close()">Cancel</button>
      <button [disabled]="isBusy" class="btn btn-lg btn-danger position-relative" (click)="rejectClaim()">
        <span
            class="spinner fade spinner-border spinner-border-sm position-absolute top-0 bottom-0 start-0 end-0 m-auto"
            role="status"
            aria-hidden="true"
            [ngClass]="{'show': isBusy}">
        </span>
        <span class="text fade show" [ngClass]="{'show': !isBusy}">
          <svg 
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="feather feather-x">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
          Reject Claim
        </span>
      </button>
    </div>
  </div>
</ng-container>